import { render, staticRenderFns } from "./partnerLog.vue?vue&type=template&id=664ddceb&scoped=true"
import script from "./partnerLog.vue?vue&type=script&lang=js"
export * from "./partnerLog.vue?vue&type=script&lang=js"
import style0 from "./partnerLog.vue?vue&type=style&index=0&id=664ddceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ddceb",
  null
  
)

export default component.exports